// Official BBB Accredited Business seal (high-resolution asset provided by the client).
// Linked to the official BBB profile. Do not modify the seal image itself.
export const BBBSeal = ({ width = 180, className = '' }) => (
  <a
    href="https://www.bbb.org/us/fl/pompano-beach/profile/health-insurance/calyvra-insurance-agency-0633-92063248/#sealclick"
    target="_blank"
    rel="nofollow noopener noreferrer"
    className={`inline-block ${className}`}
    data-testid="bbb-seal-link"
  >
    <img
      src="/bbb-accredited-business.webp"
      alt="Calyvra Insurance Agency BBB Accredited Business"
      style={{ border: 0, width: `${width}px`, height: 'auto', maxWidth: '100%' }}
      data-testid="bbb-seal-img"
    />
  </a>
);

export default BBBSeal;
